module.exports = {"bewizr-agenda":{"empty":{"title":"No activities","detail":"You have no activities scheduled."}}}